// extracted by mini-css-extract-plugin
export default {"Folder":"Folder_Folder__AcVQX","Folder__Icon":"Folder_Folder__Icon__OA8uR"};